/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Breadcrumb , Card , Row , Col} from 'react-bootstrap'
import Wizard from '../components/assignments/wizard.js'
import EditWizard from '../components/assignments/edit_wizard.js'
import DuplicateWizard from '../components/assignments/duplicate_wizard.js'
import LibraryWizard from '../components/assignments/library_wizard.js'
import LibraryWizardFake from '../components/assignments/library_wizard_fake.js'
import Management from '../components/assignments/pages/management.js';
import Translation from '../store/internationalization-store.js';
import HomeworkStore from '../store/homework-store.js';
import HomeworkDetail from '../components/assignments/pages/detail.js';
import HomeworkDetailLibrary from '../components/assignments/pages/detail_library.js';
import HomeworkDetailLibraryFake from '../components/assignments/pages/detail_library_fake.js';


export default class Library extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:this.props.match.params.tab,
            additionalContentItems:[
                {id:"songs_and_stories" , name:"Stories" , disabled:false},
                {id:"songs_and_stories" , name:"Songs"    , disabled:false},
                {id:"lessons" , name:"Lessons Plans" , disabled:false},
                {id:"" , name:"Content Map" , disabled:false},
                {id:"" , name:"Content Overview" , disabled:false},
            ],
            personalItems:[
                {id:"create_assignment" , name:"Create Assignments"    , disabled:false},
                {id:"" , name:"Custom Vocabulary Bank"    , disabled:false},
                {id:"" , name:"Custom Exam"    , disabled:true},
                {id:"" , name:"Custom Grammars"    , disabled:true},
                {id:"" , name:"Custom Sentences"    , disabled:true},
            ],
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(eventKey){
        window.location.hash = "assignments/"+eventKey;
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            tab:this.props.match.params.tab,
        })
    }

    getBody(){
        HomeworkStore.clear();
        switch(this.state.tab)
        {
            case "create" : return <Wizard/>
            case "edit" : return <EditWizard homeworkID={this.props.match.params.homeworkID}/>
            case "editNew" : return <EditWizard homeworkID={this.props.match.params.homeworkID} secondPhase={true}/>
            case "duplicate" : return <DuplicateWizard homeworkID={this.props.match.params.homeworkID}/>
            case "libraryAssign" : return <LibraryWizard homeworkID={this.props.match.params.homeworkID} 
                    curriculumID={this.props.match.params.curriculumID}
                    languageID={this.props.match.params.languageID}/>
            case "libraryAssignFake" : return <LibraryWizardFake homeworkID={this.props.match.params.homeworkID}/>
            case "overview":return <HomeworkDetail homeworkID={this.props.match.params.homeworkID} />
            case "library":return <HomeworkDetailLibrary homeworkID={this.props.match.params.homeworkID} 
                    curriculumID={this.props.match.params.curriculumID} languageID={this.props.match.params.languageID}/>
            case "libraryFake":return <HomeworkDetailLibraryFake homeworkID={this.props.match.params.homeworkID}/>
            default: return <Management/>;
        }

    }

    getBreadCrumb(){

        switch(this.state.tab)
        {
            case "create":return Translation.get(12733 , 'Create Assignment')
            case "management" : return Translation.get(12734 , 'Assignment Management');
            case "overview" : return Translation.get(2216 , 'Overview');
            case "library" : return Translation.get(2442 , 'Assignment Library');
            default : return Translation.get(2216 , 'Overview');
        }

    }


    render(){


        return <div>
                    <Row>
                        <Col sm={12} md={12}>
                            <Breadcrumb>
                                <Breadcrumb.Item href="#/assignments/management">{Translation.get(12052 , 'Assignments')}</Breadcrumb.Item>
                                <Breadcrumb.Item active>{this.getBreadCrumb()}</Breadcrumb.Item>
                            </Breadcrumb>
                            <Card body>
                                {this.getBody()}
                            </Card>
                        </Col>
                    </Row>
                </div>


    }

}